/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360RetailerApiContractInformationCardInformationCardFilter {
    CardID?: string;
    CardName?: string;
    /**
     * 1 = NotArchived, 2 = Archived, 3 = Active
     */
    State?: Open360RetailerApiContractInformationCardInformationCardFilter.StateEnum;
    Limit?: number;
    Offset?: number;
    SortColumn?: string;
    /**
     * 0 = Ascending, 1 = Descending
     */
    SortOrder?: Open360RetailerApiContractInformationCardInformationCardFilter.SortOrderEnum;
}
export namespace Open360RetailerApiContractInformationCardInformationCardFilter {
    export type StateEnum = 1 | 2 | 3;
    export const StateEnum = {
        NUMBER_1: 1 as StateEnum,
        NUMBER_2: 2 as StateEnum,
        NUMBER_3: 3 as StateEnum
    }
    export type SortOrderEnum = 0 | 1;
    export const SortOrderEnum = {
        NUMBER_0: 0 as SortOrderEnum,
        NUMBER_1: 1 as SortOrderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360RetailerApiContractInformationCardInformationCardFilter.ts